export default "4cde1e0ee1945875.svg"